import { Skeleton } from "@/design-system";
import { Footer, Header, WhatsAppFloatButton } from "@/pages/landingPage/components";
import type { ReactNode } from "react";

/**
 * Moldura do hub de cluster.
 *
 * Existe para que os três estados da página (carregando, erro e conteúdo)
 * nasçam com o mesmo cabeçalho, a mesma largura e o mesmo respiro — é o que
 * evita a tela saltar quando o conteúdo chega.
 */
export const ClusterPageShell = ({ children }: { children: ReactNode }) => (
  <div className="bg-ds-paper min-h-screen">
    <Header />
    <main className="mx-auto w-full max-w-6xl px-4 pt-28 pb-16 sm:px-6">
      {children}
    </main>
    <Footer />
    <WhatsAppFloatButton />
  </div>
);

/**
 * Esqueleto do hub, com a mesma silhueta do conteúdo real: trilha, título,
 * descrição, destaque do pilar e a grade dos satélites. Esqueleto em vez de
 * spinner porque o layout fica parado quando os dados chegam.
 */
export const ClusterPageSkeleton = () => (
  <ClusterPageShell>
    <div role="status" aria-busy="true">
      <span className="sr-only">Carregando os conteúdos do tema</span>
      <Skeleton className="h-4 w-48" />
      <Skeleton className="mt-6 h-10 w-4/5 max-w-xl" />
      <Skeleton className="mt-4 h-4 w-3/5 max-w-lg" />
      <Skeleton className="rounded-ds-lg mt-10 h-56 w-full" />
      <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton key={i} className="rounded-ds-lg h-64 w-full" />
        ))}
      </div>
    </div>
  </ClusterPageShell>
);
